import firebase from 'firebase/compat/app';
import 'firebase/compat/database';

const FirebaseDatabaseReference = firebase.database.Reference;

export default FirebaseDatabaseReference;
